import { render, staticRenderFns } from "./MaterialScoreInput.vue?vue&type=template&id=3b2caa14&scoped=true"
import script from "./MaterialScoreInput.vue?vue&type=script&lang=js"
export * from "./MaterialScoreInput.vue?vue&type=script&lang=js"
import style0 from "./MaterialScoreInput.vue?vue&type=style&index=0&id=3b2caa14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2caa14",
  null
  
)

export default component.exports